import { LegalRedirect } from "@/components/legal-redirect";

/** The member terms of use are published on the environment's site (nodus.se/anvandarvillkor); no copy here. */
export default function TermsPage() {
  return <LegalRedirect doc="terms" />;
}
